// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".newsletter-container[data-v-253fa790] {\n  width: 100%;\n}[dir] .newsletter-container[data-v-253fa790] {\n  padding: 1rem 0;\n}", ""]);
// Exports
module.exports = exports;
